"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const faBell_1 = require("@fortawesome/pro-solid-svg-icons/faBell");
const faTimes_1 = require("@fortawesome/pro-solid-svg-icons/faTimes");
const icons_1 = require("../../atoms/icons");
const hooks_1 = require("../../shared/hooks");
const NotificationActions = ({ notifications }) => {
    const { isOffline } = (0, hooks_1.useNetwork)();
    if (!notifications || notifications.length === 0)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: notifications.map((not, idx) => {
            return ((0, jsx_runtime_1.jsx)(Notification, { index: idx, content: not.content, onClose: not.onClose, isDismissable: not.isDismissable, isOffline: isOffline }, idx));
        }) }, void 0));
};
exports.NotificationActions = NotificationActions;
const Notification = ({ index, onClose, content, isDismissable, isOffline }) => {
    const handleClose = () => {
        if (!isDismissable || isOffline)
            return;
        onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { index: index, disabled: !isDismissable || isOffline, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faBell_1.faBell, color: "yellow", size: "sm" }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: content }, void 0), (0, jsx_runtime_1.jsx)("div", { onClick: handleClose, children: isDismissable && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: faTimes_1.faTimes, color: isOffline ? "lighten-grey" : "grey" }, void 0)) }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: flex;
  min-height: 2.5rem;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacings.xs} ${theme.spacings.m}`};
  top: ${({ index }) => index * 2.5}rem;
  position: sticky;
  width: calc(100% + 2rem);
  transform: translateX(-1rem);
  z-index: 20;

  & > div:first-of-type,
  & > div:last-of-type {
    align-self: flex-start;
    flex: 0;
  }

  & > div:nth-of-type(2) {
    flex: 1;
    padding: ${({ theme }) => `0 ${theme.spacings.xs}`};

    p,
    a {
      font-size: 0.75rem;
      font-weight: 600;
    }

    a {
      color: ${({ theme }) => theme.colors.blueBase};
    }

    a:hover {
      text-decoration: underline;
    }
  }

  & > div:first-of-type {
    background-color: ${({ theme }) => theme.colors.yellowLighten80};
    border-radius: 50%;
    height: 1.5rem;
    width: 1.5rem;
  }

  & > div:last-of-type {
    align-items: center;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    display: flex;
    height: 1.5rem;
    justify-content: center;
    width: 1.5rem;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    transform: translateX(0);
    width: 100%;
  }
`;
//# sourceMappingURL=index.js.map